// extracted by mini-css-extract-plugin
export var footer = "_ql-5";
export var fulfillmentInput = "_ql-0";
export var shipDateInput = "_ql-1";
export var shipmentModal = "_ql-2";
export var shipmentModalContent = "_ql-3";
export var tableContainer = "_ql-4";